import { useTranslation } from "react-i18next";

import React from 'react';
import styled from 'styled-components';
import './style.scss';
import {Button, PopUp} from "components/common"
import LogoutIcon from './assets/images/logouticon.svg';
import {useDispatch} from "react-redux";
import {logout} from "../../store/modules/users/authReducer";
import {resetProfileState} from 'store/modules/profile/profileReducer';
import {useHistory} from "react-router-dom";
import api from "services/api";

const LogoutModalWrapper = styled.div`
  width: 100%;
`;

export const LogoutModal :React.FC = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    const history = useHistory();
    const logoutNow = () => {
        dispatch(logout());
        dispatch(resetProfileState());
        api.deleteToken()
        return history.push('/login');
    }

    return (
        <LogoutModalWrapper id={"logout-modal"}>
            <button type="button" id={"logout-btn"} className="d-none" data-bs-toggle="modal" data-bs-target="#logoutModal"/>
            <div className="modal fade" id="logoutModal" data-bs-backdrop="static" data-bs-keyboard="false"
                 tabIndex={-1} aria-labelledby="logoutModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <PopUp type={t("log_out_type")} onClose={() => {
                            //@ts-ignore
                            document.getElementById("logout-btn-close").click()
                        }}>
                            <div className={"logout-modal-content"}>
                                <img src={LogoutIcon}/>
                                <h2 className={"logout-title"}>{ t("are_you_sure_you_want_to_log_out_tag_plain")}</h2>
                                <p className={"logout-subtitle"}>{ t("your_security_session_will_be_terminated") }</p>
                                <div className={"d-flex align-items-center"}>
                                    <Button onPress={() => {
                                        //@ts-ignore
                                        document.getElementById("logout-btn-close").click()
                                    }} type={"button"} btnStyle={"secondary"} text={t("cancel_text")} customClass={'logout-btn'} />
                                    <div style={{ marginLeft: 12 }}>
                                        <Button onPress={() => {
                                            //@ts-ignore
                                            document.getElementById("logout-btn-close").click()
                                            logoutNow()
                                        }} btnStyle={"primary"} text={t("log_out_text")} customClass={'logout-btn'} />
                                    </div>
                                </div>
                            </div>
                        </PopUp>
                        <button type="button" id={"logout-btn-close"} className="d-none"  data-bs-dismiss="modal"/>
                        {/*<div className="modal-header">*/}
                        {/*    <h5 className="modal-title" id="staticBackdropLabel">Modal title</h5>*/}
                        {/*    <button type="button" className="btn-close" data-bs-dismiss="modal"*/}
                        {/*            aria-label="Close"></button>*/}
                        {/*</div>*/}
                        {/*<div className="modal-body">*/}
                        {/*    ...*/}
                        {/*</div>*/}
                        {/*<div className="modal-footer">*/}
                        {/*    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t("close_tag_plain")}</button>*/}
                        {/*    <button type="button" className="btn btn-primary">{ t("understood_tag_plain") }</button>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        </LogoutModalWrapper>
    )
};

export default LogoutModal;